import React from "react"
import PropTypes from "prop-types"
import useAdminCityName from "../../hooks/useAdminCityName"

/**
 * Manage City listing toolbar title — page label + resolved city name.
 */
const AdminCityListingTitle = ({ label, cityId, className = "" }) => {
  const cityName = useAdminCityName(cityId)

  return (
    <div
      className={`admin-city-listing-title${
        className ? ` ${className}` : ""
      }`}
    >
      <h1 className="admin-city-listing-title__label">{label}</h1>
      {cityName ? (
        <span className="admin-city-listing-title__city">{cityName}</span>
      ) : null}
    </div>
  )
}

AdminCityListingTitle.propTypes = {
  label: PropTypes.string.isRequired,
  cityId: PropTypes.string,
  className: PropTypes.string,
}

AdminCityListingTitle.defaultProps = {
  cityId: undefined,
  className: "",
}

export default AdminCityListingTitle
